export default __webpack_public_path__ + "images/copy-yellow-icon.svg";